import * as angular from 'angular';

import datacatalog from './datacatalog-services';
import init from './init';

export default class UpdateDatacatalogService {

    constructor(
        private readonly datacatalog: datacatalog
    ) {}

    updateDatacatalog(): angular.IPromise<datacatalog> {
       return init(this.datacatalog);
    }
}

UpdateDatacatalogService.$inject = ['datacatalog'];